import { environment } from './environment';
export const CONST = Object.freeze({
  SESSION_NAME: 'privacyportal',
  ENV_URL_DEV: environment.restUrlDev,
  ENV_URL_UAT: environment.restUrlUat,
  ENV_URL_PROD: environment.restUrlProd,
  NexGen_URL: environment.profileId,
  LOGIN_URL_DSR_FORM: environment.loginUrlDsrFrom,
  LOGIN_URL_DSR_STATUS: environment.loginUrlDsrStatus,
  CHAT_BOT_IFRAME_URL: environment.chatbotIframeUrl,
  SESSION: {
    CHECK_SESSION: environment.idaasUserStatus,
    UNAUTHENTICATED: 'Unauthenticated',
    AUTHENTICATED: 'Authenticated',
  },
  PAGE_TITLE: {
    CONTACT_US: 'Contact IBM Privacy',
    DSR: 'DSR Submission',
    DSR_STATUS: 'Track DSR Request',
  },
  EMPTY_ANCHOR_TAG: 'javascript:;',
  PATH: {
    CONTACT_CC: '/privacy/requests/contact/:cc',
    CONTACT: '/privacy/requests/contact',
    HOME_CC: '/privacy/requests/home/:cc',
    HOME: '/privacy/requests/home',
    DSR_CC: '/privacy/requests/:cc',
    DSR: '/privacy/requests/',
    DSR_STATUS_CC: '/privacy/requests/dsr/:cc',
    DSR_STATUS: '/privacy/requests/dsr',
  },
  DSR_STEPS_API_VALUE: {
    RECEIVED: 'Received',
    PENDING_VERIFICATION: 'Pending verification/clarification',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    CLOSED: 'Closed',
    CANCELLED: 'Cancelled',
  },
  STRING: {
    DSR_FORM: 'dsr',
    HELPDESK: 'helpdesk',
    MAP: 'map',
    EAMIL: 'email',
    CMT: 'cmt',
    INTERNAL: 'internal',
    EXTERNAL: 'external',
  },
  USER_TYPE: {
    EXTERNAL: 'cloudIdentityRealm',
  },
  EMAIL: {
    DSR_FORM: 'Chiefprivacyoffice@ca.ibm.com',
    DSR_MAIL_ID: 'DSR.Requests@ca.ibm.com',
  },
  CONTACT_FORM: {
    CONTACT: 'Contact_select_page',
    ONLINE_STATEMENT: 'onlinestatement',
    PRIVACY_POLICY: 'privacypolicy',
    DATA_COMPLAINT: 'datacomplaint',
    EU_REQUEST: 'eurequest',
    SUPPORT: 'support',
    UN_SUBSCRIBE: 'unsubscribe',
    DATA_REQUEST: 'submitdatarequest',
    EMAIL_WINDOW: 'emailwindow',
  },
  HELPDESK_FORM: {
    REL_TYPE: 'ibmRelType',
    QUERY_TYPE: 'queryType',
    STATE_TYPE: 'state',
  },
  COUNTRY_US: 237,
  COUNTRY_CAN: 41,
  COUNTRY_US_CC: 'us-en',
  WORLDMAP_DEFAULT_CONTENT: {
    FIRST_URL_TITLE: 'IBM Privacy Statement',
    FIRST_URL: 'https://www.ibm.com/privacy',
    FIRST_URL_CONTENT:
      "This Privacy Statement describes IBM's general privacy practices that apply to personal information we collect, use and share about our clients, business partners, supplier and other organizations with which IBM has or contemplates a business relationship as well as the individuals working for them.",
    SECOND_URL_TITLE: 'IBM Online Privacy Statement',
    SECOND_URL: 'https://www.ibm.com/privacy/details',
    SECOND_URL_CONTENT:
      "This Statement discloses the information practices for IBM's and our subsidiaries' websites, what type of information about our websites' users is gathered and tracked, and how the information is used, shared or otherwise processed offline. It also describes how cookies, web beacons and other technologies may be used in our IBM Cloud services and software products.",
    FOURTH_URL_TITLE: 'Contact IBM Privacy',
    FOURTH_URL: 'https://www.ibm.com/privacy/portal/contact/us-en',
  },
  OPTOUT_URL: [
    {
      cclc: 'fr-fr',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/fr-fr',
    },
    {
      cclc: 'ca-fr',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/fr-fr',
    },
    {
      cclc: 'br-pt',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/br-pt',
    },
    {
      cclc: 'pt-pt',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/br-pt',
    },
    {
      cclc: 'de-de',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/de-de',
    },
    {
      cclc: 'tw-zh',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/tw-zh',
    },
    {
      cclc: 'it-it',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/it-it',
    },
    {
      cclc: 'jp-ja',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/jp-ja',
    },
    {
      cclc: 'kr-ko',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/kr-ko',
    },
    {
      cclc: 'pl-pl',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/pl-pl',
    },
    {
      cclc: 'ru-ru',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/ru-ru',
    },
    {
      cclc: 'tr-tr',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/tr-tr',
    },
    {
      cclc: 'cn-zh',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/cn-zh',
    },
    {
      cclc: 'es-es',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/es-es',
    },
    {
      cclc: 'dk-da',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'fi-fi',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'gr-el',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'nl-nl',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'no-no',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'il-he',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'ae-ar',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/ae-ar',
    },
    {
      cclc: 'ar-es',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/mx-es',
    },
    {
      cclc: 'se-sv',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'bg-bg',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'hr-hr',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'ee-et',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'hu-hu',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'kz-kk',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'my-ms',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'ro-ro',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'rs-sr',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'si-sl',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'ua-uk',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'uz-uz',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
    {
      cclc: 'us-en',
      url: 'https://myibm.ibm.com/profile/dataprivacypreferences/welcome/us-en',
    },
  ],
  SUPPORT_URL: [
    {
      cclc: 'fr-fr',
      url: 'https://www.ibm.com/ibmid/myibm/help/fr/helpdesk.html',
    },
    {
      cclc: 'ca-fr',
      url: 'https://www.ibm.com/ibmid/myibm/help/fr/helpdesk.html',
    },
    {
      cclc: 'pt-pt',
      url: 'https://www.ibm.com/ibmid/myibm/help/br/helpdesk.html',
    },
    {
      cclc: 'br-pt',
      url: 'https://www.ibm.com/ibmid/myibm/help/br/helpdesk.html',
    },
    {
      cclc: 'es-es',
      url: 'https://www.ibm.com/ibmid/myibm/help/es/helpdesk.html',
    },
    {
      cclc: 'ar-es',
      url: 'https://www.ibm.com/ibmid/myibm/help/es/helpdesk.html',
    },
    {
      cclc: 'de-de',
      url: 'https://www.ibm.com/ibmid/myibm/help/de/helpdesk.html',
    },
    {
      cclc: 'tw-zh',
      url: 'https://www.ibm.com/ibmid/myibm/help/tw/helpdesk.html',
    },
    {
      cclc: 'it-it',
      url: 'https://www.ibm.com/ibmid/myibm/help/it/helpdesk.html',
    },
    {
      cclc: 'jp-ja',
      url: 'https://www.ibm.com/ibmid/myibm/help/jp/helpdesk.html',
    },
    {
      cclc: 'kr-ko',
      url: 'https://www.ibm.com/ibmid/myibm/help/kr/helpdesk.html',
    },
    {
      cclc: 'pl-pl',
      url: 'https://www.ibm.com/ibmid/myibm/help/pl/helpdesk.html',
    },
    {
      cclc: 'ru-ru',
      url: 'https://www.ibm.com/ibmid/myibm/help/ru/helpdesk.html',
    },
    {
      cclc: 'tr-tr',
      url: 'https://www.ibm.com/ibmid/myibm/help/tr/helpdesk.html',
    },
    {
      cclc: 'cn-zh',
      url: 'https://www.ibm.com/ibmid/myibm/help/cn/helpdesk.html',
    },
    {
      cclc: 'uk-en',
      url: 'https://www.ibm.com/ibmid/myibm/help/uk/helpdesk.html',
    },
    {
      cclc: 'us-en',
      url: 'https://wwwstage.ibm.com/ibmweb/myibm/us-en/profile',
    },
  ],
  RIGHTS_URL: [
    {
      cclc: 'fr-fr',
      url: 'https://www.ibm.com/fr-fr/privacy#anchor-278704998',
    },
    {
      cclc: 'ca-fr',
      url: 'https://www.ibm.com/ca-fr/privacy#anchor--2068620518',
    },
    {
      cclc: 'br-pt',
      url: 'https://www.ibm.com/br-pt/privacy#anchor--2002566799',
    },
    {
      cclc: 'pt-pt',
      url: 'https://www.ibm.com/pt-pt/privacyanchor--2085999982',
    },
    {
      cclc: 'de-de',
      url: 'https://www.ibm.com/de-de/privacy#anchor--24652738',
    },
    {
      cclc: 'tw-zh',
      url: 'https://www.ibm.com/tw-zh/privacy#anchor-1592688370',
    },
    {
      cclc: 'it-it',
      url: 'https://www.ibm.com/it-it/privacy#anchor-1072776882',
    },
    {
      cclc: 'jp-ja',
      url: 'https://www.ibm.com/jp-ja/privacy#anchor-2104765178',
    },
    {
      cclc: 'kr-ko',
      url: 'https://www.ibm.com/kr-ko/privacy#anchor-821397255',
    },
    {
      cclc: 'pl-pl',
      url: 'https://www.ibm.com/pl-pl/privacy#anchor--1175538726',
    },
    {
      cclc: 'ru-ru',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'tr-tr',
      url: 'https://www.ibm.com/tr-tr/privacy#anchor-1609446287',
    },
    {
      cclc: 'cn-zh',
      url: 'https://www.ibm.com/cn-zh/privacy#anchor-1684815747',
    },
    {
      cclc: 'es-es',
      url: 'https://www.ibm.com/es-es/privacy#anchor-1315657515',
    },
    {
      cclc: 'dk-da',
      url: 'https://www.ibm.com/us-en/privacy#YourRight',
    },
    {
      cclc: 'fi-fi',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'gr-el',
      url: 'https://www.ibm.com/gr-el/privacy#anchor-1687789726',
    },
    {
      cclc: 'nl-nl',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'no-no',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'il-he',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'ae-ar',
      url: 'https://www.ibm.com/ae-ar/privacy',
    },
    {
      cclc: 'ar-es',
      url: 'https://www.ibm.com/la-es/privacy#anchor--170120564',
    },
    {
      cclc: 'se-sv',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'bg-bg',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'hr-hr',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'ee-et',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'hu-hu',
      url: 'https://www.ibm.com/hu-hu/privacy#anchor-494716676',
    },
    {
      cclc: 'kz-kk',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'my-ms',
      url: 'https://www.ibm.com/my-ms/privacy#anchor--1811988487',
    },
    {
      cclc: 'ro-ro',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'rs-sr',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'si-sl',
      url: 'https://www.ibm.com/si-sl/privacy#anchor--1261082898',
    },
    {
      cclc: 'ua-uk',
      url: 'https://www.ibm.com/ua-uk/privacy#anchor--1423833008',
    },
    {
      cclc: 'uz-uz',
      url: 'https://www.ibm.com/us-en/privacy#YourRights',
    },
    {
      cclc: 'us-en',
      url: 'https://wwwstage.ibm.com/ibmweb/myibm/us-en/profile',
    },
  ],
});
